import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-63b58ecc")

_pushScopeId("data-v-63b58ecc")
const _hoisted_1 = { class: "grid gap-6 grid-cols-2" }
const _hoisted_2 = {
  key: 0,
  class: "flex flex-col"
}
const _hoisted_3 = { class: "font-semibold text-14px" }
const _hoisted_4 = { class: "flex flex-row py-4" }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = {
  style: {"background-color":"#D8EEFB"},
  class: "flex rounded-md flex-row gap-x-3 py-3 px-4 items-center"
}
const _hoisted_7 = /*#__PURE__*/_createVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}, [
  /*#__PURE__*/_createVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M18.3642 18.3641C16.6764 20.0519 14.3872 21.0001 12.0002 21.0001C9.6133 21.0001 7.32411 20.0519 5.63628 18.3641C3.94846 16.6763 3.00024 14.3871 3.00024 12.0001C3.00024 10.8182 3.23304 9.6479 3.68533 8.55597C4.13762 7.46404 4.80056 6.47189 5.63628 5.63616C6.47201 4.80043 7.46416 4.1375 8.55609 3.68521C9.64802 3.23291 10.8183 3.00012 12.0002 3.00012C13.1821 3.00012 14.3525 3.23291 15.4444 3.68521C16.5363 4.1375 17.5285 4.80043 18.3642 5.63616C19.1999 6.47189 19.8629 7.46404 20.3152 8.55597C20.7675 9.6479 21.0002 10.8182 21.0002 12.0001C21.0002 14.3871 20.052 16.6763 18.3642 18.3641ZM12.0002 16.5001C11.5032 16.5001 11.1002 16.0972 11.1002 15.6001L11.1002 12.0001C11.1002 11.5031 11.5032 11.1001 12.0002 11.1001C12.4973 11.1001 12.9002 11.5031 12.9002 12.0001L12.9002 15.6001C12.9002 16.0972 12.4973 16.5001 12.0002 16.5001ZM12.9002 8.40012C12.9002 8.89718 12.4973 9.30012 12.0002 9.30012H11.9912C11.4942 9.30012 11.0912 8.89718 11.0912 8.40012C11.0912 7.90307 11.4942 7.50012 11.9912 7.50012H12.0002C12.4973 7.50012 12.9002 7.90307 12.9002 8.40012Z",
    fill: "#2468F6"
  })
], -1)
const _hoisted_8 = {
  class: "text-14px font-normal",
  style: {"color":"#2468F6"}
}
const _hoisted_9 = { class: "w-32" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_lp_input = _resolveComponent("lp-input")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_Datepicker = _resolveComponent("Datepicker")!
  const _component_component_select_delivered_by = _resolveComponent("component-select-delivered-by")!
  const _component_RadioButton = _resolveComponent("RadioButton")!
  const _component_SelectSearch = _resolveComponent("SelectSearch")!
  const _component_SelectSearchV2 = _resolveComponent("SelectSearchV2")!
  const _component_lp_button = _resolveComponent("lp-button")!
  const _component_Notification = _resolveComponent("Notification")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_DataWrapper, {
        label: _ctx.$t('updateDelivery.form.partnerName')
      }, {
        default: _withId(() => [
          _createVNode(_component_lp_input, {
            modelValue: _ctx.partnerName,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.partnerName = $event)),
            disabled: ""
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }, 8, ["label"]),
      _createVNode(_component_DataWrapper, {
        label: _ctx.$t('updateDelivery.form.userType')
      }, {
        default: _withId(() => [
          _createVNode(_component_lp_input, {
            modelValue: _ctx.typeUser,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.typeUser = $event)),
            disabled: ""
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }, 8, ["label"]),
      _createVNode(_component_DataWrapper, {
        label: _ctx.$t('updateDelivery.form.originCity')
      }, {
        default: _withId(() => [
          _createVNode(_component_lp_input, {
            modelValue: _ctx.originCity,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.originCity = $event)),
            placeholder: "-",
            disabled: ""
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }, 8, ["label"]),
      _createVNode(_component_DataWrapper, {
        label: _ctx.$t('updateDelivery.form.dateCreated')
      }, {
        default: _withId(() => [
          _createVNode(_component_Datepicker, {
            class: "mt-1.5",
            disabled: "",
            modelValue: _ctx.form.dateCreated,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.form.dateCreated = $event)),
            placeholder: _ctx.$t('updateDelivery.form.datePlaceholder')
          }, null, 8, ["modelValue", "placeholder"])
        ]),
        _: 1
      }, 8, ["label"]),
      _createVNode(_component_DataWrapper, {
        label: _ctx.$t('updateDelivery.form.deliveredBy')
      }, {
        default: _withId(() => [
          _createVNode(_component_component_select_delivered_by, {
            class: "mt-1.5",
            modelValue: _ctx.form.deliveredBy,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.form.deliveredBy = $event)),
            onOnChangeRadiobutton: _ctx.onChangeDeliveryType
          }, null, 8, ["modelValue", "onOnChangeRadiobutton"])
        ]),
        _: 1
      }, 8, ["label"]),
      (_ctx.isAccountConsoleOrSubconsole)
        ? (_openBlock(), _createBlock("div", _hoisted_2, [
            _createVNode("p", _hoisted_3, _toDisplayString(_ctx.$t("updateDelivery.form.driverUsesApp")), 1),
            _createVNode("div", _hoisted_4, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dataTypes, (item, index) => {
                return (_openBlock(), _createBlock("div", {
                  key: index,
                  class: "w-1/6 p-field-radiobutton gap-x-3 flex flex-row lp-radio"
                }, [
                  _createVNode(_component_RadioButton, {
                    id: `radio-${item.value}`,
                    name: "report-type",
                    value: item.value,
                    modelValue: _ctx.form.dataType,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.form.dataType = $event)),
                    onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.form.courier = ''))
                  }, null, 8, ["id", "value", "modelValue"]),
                  _createVNode("label", {
                    for: `radio-${item.value}`
                  }, _toDisplayString(item.name), 9, ["for"])
                ]))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_DataWrapper, {
        label: _ctx.$t('updateDelivery.form.driverName')
      }, {
        default: _withId(() => [
          (_ctx.form.dataType === 'Tidak')
            ? (_openBlock(), _createBlock(_component_SelectSearch, {
                key: 0,
                "is-loading": _ctx.loadingDriver,
                onFocus: _ctx.fetchDrivers,
                serverSide: false,
                "onSubmit:driver": _ctx.onCreatedDriver,
                addDriver: true,
                class: "mt-1.5",
                options: _ctx.driverOptions,
                keyName: "driverInfo",
                keyValue: "driverId",
                modelValue: _ctx.form.courier,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.form.courier = $event)),
                placeholder: _ctx.$t('updateDelivery.form.selectDriver')
              }, null, 8, ["is-loading", "onFocus", "onSubmit:driver", "options", "modelValue", "placeholder"]))
            : (_openBlock(), _createBlock(_component_SelectSearchV2, {
                key: _ctx.form.courier,
                onFilter: _ctx.onFilterCourierAlgo,
                onFocus: _ctx.fetchDrivers,
                isLoading: _ctx.loadingDriver,
                options: _ctx.driverOptions,
                keyName: "driverInfo",
                keyValue: "driverId",
                placeholder: _ctx.$t('updateDelivery.form.selectClientPartner'),
                modelValue: _ctx.form.courier,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.form.courier = $event))
              }, null, 8, ["onFilter", "onFocus", "isLoading", "options", "placeholder", "modelValue"]))
        ]),
        _: 1
      }, 8, ["label"]),
      (_ctx.form.dataType === 'Tidak')
        ? (_openBlock(), _createBlock("div", _hoisted_5, [
            _createVNode("div", _hoisted_6, [
              _hoisted_7,
              _createVNode("p", _hoisted_8, _toDisplayString(_ctx.$t("updateDelivery.form.deliveryNote")), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_DataWrapper, {
        class: "col-span-2",
        label: _ctx.$t('updateDelivery.form.noStt')
      }, {
        default: _withId(() => [
          _createVNode(_component_lp_input, {
            ref: "inputStt",
            onEnter: _ctx.validateSttNoToUpdate,
            sizeInput: "24px",
            labelStacked: _ctx.$t('updateDelivery.form.noSttLabel'),
            modelValue: _ctx.scanSttNumber,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.scanSttNumber = $event)),
            placeholder: _ctx.$t('updateDelivery.form.noSttPlaceholder'),
            bold: !!_ctx.scanSttNumber,
            error: !_ctx.isPaid,
            onChange: _cache[11] || (_cache[11] = ($event: any) => (_ctx.setIsPaid(true))),
            errorCaption: 
          !_ctx.isPaid
            ? _ctx.$t('updateDelivery.form.weightExcessError')
            : ''
        
          }, null, 8, ["onEnter", "labelStacked", "modelValue", "placeholder", "bold", "error", "errorCaption"])
        ]),
        _: 1
      }, 8, ["label"]),
      _createVNode("div", _hoisted_9, [
        _createVNode(_component_lp_button, {
          onClick: _ctx.validateSttNoToUpdate,
          customClass: "px-12 py-2.5 w-full",
          title: _ctx.$t('updateDelivery.form.add'),
          textColor: "white",
          disabled: _ctx.isDisabledAdd
        }, null, 8, ["onClick", "title", "disabled"])
      ])
    ]),
    _createVNode(_component_Notification, {
      modelValue: _ctx.notification,
      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.notification = $event)),
      onClose: _ctx.onCloseNotification,
      data: _ctx.sttNotification,
      status: _ctx.isUnpaidNotification ? 'error' : 'success'
    }, null, 8, ["modelValue", "onClose", "data", "status"])
  ], 64))
})